import ResourceFields from "./ResourceFields";
export const AdditionalComponentsModule = () => {
    return {
        components: {
            resourcefields: ResourceFields,
        },
    };
};
